import { render, staticRenderFns } from "./ApplyRecordDetail.vue?vue&type=template&id=34b3dbe9&scoped=true"
import script from "./ApplyRecordDetail.vue?vue&type=script&lang=js"
export * from "./ApplyRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./ApplyRecordDetail.vue?vue&type=style&index=0&id=34b3dbe9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b3dbe9",
  null
  
)

export default component.exports